module.exports = __webpack_public_path__ + "img/soft-grove-bathroom-5.9392d04c.jpeg";